type GreetingType = {
  hours: number[];
  messageKey: string;
}[];

export const timeToGreetingKey = (): string => {
  const now = new Date();
  const greetingsDictionary: GreetingType = [
    {
      hours: [2, 3, 4, 5, 6, 7, 8],
      messageKey: 'LOGIN_LOGOUT_HEADLINE_MORNING',
    },
    {
      hours: [9, 10, 11, 12, 13, 14, 15, 16, 17],
      messageKey: 'LOGIN_LOGOUT_HEADLINE_DAY',
    },
    {
      hours: [18, 19, 20, 21, 22, 23, 0, 1],
      messageKey: 'LOGIN_LOGOUT_HEADLINE_NIGHT',
    },
  ];

  const greeting = greetingsDictionary.find(({ hours }) =>
    hours.includes(now.getHours())
  );

  return greeting?.messageKey || 'LOGIN_LOGOUT_HEADLINE_DAY';
};
